import { useContext, useState } from 'react';
import { getNotifications, updateNotificationData } from '../../../api/update_guidance';
import Store from '../../../store';
import Actions from '../../../store/actions';

const useDeletedNotification = () => {
  const [recentNotifications, setRecentNotifications] = useState<Array<{ [key: string]: any }>>([]);
  const [toQCList, setQCList] = useState<Array<{ [key: string]: any }>>([]);

  const { dispatch } = useContext<any>(Store);

  const getRecentNotifications = async () => {
    const response = await getNotifications('recent');
    const data = response.data?.Success;
    if (data) {
      const allNotifications = [
        // Added notifications are already sent.
        ...data.added.map((d: any) => ({
          ...d,
          notiticationType: 'Added',
          notificationSentStatus: 'Sent'
        })),

        // Deleted notification may include re-appeared ones as well. So we will have to handle it accordingly.
        ...data.deleted.map((d: any) => ({
          ...d,
          notiticationType: d.notification_type || 'Deleted',
          // eslint-disable-next-line no-nested-ternary
          notificationSentStatus: d.notification_sent
            ? 'Sent'
            : d.notification_can_be_sent
            ? 'Queued'
            : 'Rejected'
        }))
      ];
      const sorted = allNotifications.sort(
        (a: any, b: any) =>
          new Date(b.notification_can_be_sent_updated_at).getTime() -
          new Date(a.notification_can_be_sent_updated_at).getTime()
      );
      setRecentNotifications(sorted);
    }
  };

  const getNotificationsToBeQced = async () => {
    const response = await getNotifications('to_qc');
    const data = response.data?.Success;
    if (data) {
      const notifications = data.to_qc.map((d: any) => ({
        ...d,
        notiticationType: d.notification_type
      }));
      const sorted = notifications.sort(
        (a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      setQCList(sorted);
    }
  };

  const updateNotificationRecord = async (id: number, updatedData: any) => {
    const response = await updateNotificationData(id, updatedData);
    const data = response.data?.Success;
    if (data && data.update_status) {
      await dispatch({
        type: Actions.SET_ALERT,
        value: { status: true, message: 'Successfully updated.', color: 'success' }
      });
    } else {
      await dispatch({
        type: Actions.SET_ALERT,
        value: { status: true, message: 'Failed to update the records' }
      });
    }
  };

  const searchThroughRecentRecords = (searchText: string) => {
    const words = searchText.toLowerCase().split(/\s+/); // Split search text into words

    return recentNotifications.filter(obj =>
      words.every((word: string) =>
        Object.entries(obj).some(
          ([key, value]) =>
            key.toLowerCase().includes(word) || String(value).toLowerCase().includes(word)
        )
      )
    );
  };

  return {
    recentNotifications,
    toQCList,
    getRecentNotifications,
    getNotificationsToBeQced,
    updateNotificationRecord,
    searchThroughRecentRecords
  };
};

export default useDeletedNotification;
